// Re-measure in Gilroy at `width: max-content` (+8px buffer, rounded up to 5) when the row's contents change.
export const HEADER_COLLAPSE_ACTIONS_WIDTH_RESTING = 795; // 783 · title + toggle | two pills
export const HEADER_COLLAPSE_ACTIONS_WIDTH_FETCHING = 1160; // 1152 · the same plus the full MCA message
export const HEADER_HIDE_TITLE_WIDTH_RESTING = 500; // 492 · title + toggle | menu
export const HEADER_HIDE_TITLE_WIDTH_FETCHING = 745; // 734 · the same plus the shortened MCA message
export const MCA_FETCH_MESSAGE = 'Fetching latest data from MCA (takes upto 24 hours)';
export const MCA_FETCH_MESSAGE_COMPACT = 'Fetching latest data from MCA…';
// Widest header ("FY'27 (Annu.)*" + icon) plus cell padding is ~140.6px; re-measure if header text or padding change.
export const VALUE_COLUMN_MIN_WIDTH = '9.25rem';
export const FINANCIAL_METRICS_DRAWER_TITLE = 'Financial Metrics';
export const ANNUALISED_HEADER_TOOLTIP_ALT = 'About annualised data';
